import {
    Denominator,
    LimitControlEntity,
    LimitType,
    Portfolio,
    SubLimitType,
    LimitControlCreateRequest,
    LimitEvaluationEnum,
} from "@/modules/limit-control/domain/entities/LimitControlEntity";

export const enrichLimitControl = (
    request: LimitControlCreateRequest,
    id: string,
    createdAt: Date,
    updatedAt: Date | null,
    context: {
        limitTypes?: LimitType[];
        subLimits?: SubLimitType[];
        denominators?: Denominator[];
        portfolios?: Portfolio[];
    }
): LimitControlEntity | null => {
    const {
        limitTypes = [],
        subLimits = [],
        denominators = [],
        portfolios = [],
    } = context;

    const limitType = limitTypes.find((lt) => lt.id.toString() === request.limitType);
    const subLimit = subLimits.find((sl) => sl.id.toString() === request.subLimit);
    const denominator = denominators.find((d) => d.id.toString() === request.denominator);
    const portfolio = portfolios.find((p) => p.id.toString() === request.portfolio);

    if (!limitType || !subLimit || !denominator || !portfolio) return null;

    return {
        id,
        limitType,
        subLimit,
        limitEvaluation: LimitEvaluationEnum[parseInt(request.limitEvaluation)] as unknown as LimitEvaluationEnum,
        percentage: request.percentage,
        denominator,
        portfolio,
        createdAt,
        updatedAt,
    };
}


export const mapToFormValues = (entity?: LimitControlEntity) =>
    entity
        ? {
            id: entity.id.toString(),
            limitType: entity.limitType?.id.toString(),
            subLimit: entity.subLimit?.id.toString(),
            limitEvaluation: LimitEvaluationEnum[entity.limitEvaluation].toString(),
            percentage: entity.percentage,
            portfolio: entity.portfolio?.id.toString(),
            denominator: entity.denominator?.id.toString(),
        }
        : undefined;